import './buy.scss';
function buttoner() {
    alert("seller has been alerted");
}
const entries = [
    <ul class="mdc-image-list product-list">
        <li class="mdc-image-list__item">
            <img class="mdc-image-list__image" src="TeslaMods.jpg" alt="pusdch" style={{ height: "243px" }} />
            <div class="mdc-image-list__supporting">
                <span class="mdc-image-list__label">Tesla Model S battery 90% Capacity</span>
            </div>
            Price:$2700 <button onClick={buttoner}>Buy</button>
        </li>
        <li class="mdc-image-list__item">
            <img class="mdc-image-list__image" src="TeslaMod3.jpg" alt="pusdch" />
            <div class="mdc-image-list__supporting">
                <span class="mdc-image-list__label">Tesla Model 3 battery 85% Capacity</span>
            </div>
            Price:$1500 <button onClick={buttoner}>Buy</button>
        </li>
        <li class="mdc-image-list__item">
            <img class="mdc-image-list__image" src="Chevyvoltbatt.jpg" alt="pusdch" style={{ height: "243px" }} />
            <div class="mdc-image-list__supporting">
                <span class="mdc-image-list__label">Chevy volt battery 55% Capacity</span>
            </div>
            Price:$1200 <button onClick={buttoner}>Buy</button>
        </li>
        <li class="mdc-image-list__item">
            <img class="mdc-image-list__image" src="priusBatt.webp" alt="pusdch" style={{ height: "243px" }} />
            <div class="mdc-image-list__supporting">
                <span class="mdc-image-list__label">Prius battery 45% Capacity</span>
            </div>
            Price:$1200 <button onClick={buttoner}>Buy</button>
        </li>
        <li class="mdc-image-list__item">
            <img class="mdc-image-list__image" src="HyundaiKonabatt.jpg" alt="pusdch" style={{ height: "243px" }} />
            <div class="mdc-image-list__supporting">
                <span class="mdc-image-list__label">Hyundai Kona battery 85% Capacity</span>
            </div>
            Price:$1200 <button onClick={buttoner}>Buy</button>
        </li>
        <li class="mdc-image-list__item">
            <img class="mdc-image-list__image" src="BMWi3batt.jpg" alt="pusdch" style={{ height: "243px" }} />
            <div class="mdc-image-list__supporting">
                <span class="mdc-image-list__label">BMW i3 battery 75% Capacity</span>
            </div>
            Price:$1200 <button onClick={buttoner}>Buy</button>
        </li>
    </ul>];
function Buy() {
    return (
        <html lang="en">

            <head>


            </head>

            <body>
                welcome to the buying page
            </body>
            <br />
            <label> choose a capacity
                <select>
                    <option>All batteries</option>
                    <option>80 and above</option>
                    <option>79-60</option>
                    <option>59 and below</option>

                </select>
            </label>
            <ol>
                {entries}
            </ol>
        </html>
    );
}

export default Buy;

